<!-- Panel mode: always-rendered banner for arrangement panels. Both buttons
     are always shown; each one is disabled when no media of that kind has
     been uploaded, with a tooltip explaining the state. -->
<div
  *ngIf="panel"
  class="mb-3 px-3 py-2 bg-blue-50 border-round-lg flex gap-3 flex-wrap align-items-center"
>
  <span class="text-700 font-medium flex-grow-1">
    <i class="pi pi-paperclip mr-2 text-600"></i>{{ headingText }}
  </span>
  <p-button
    [label]="docCount > 0 ? 'Documents (' + docCount + ')' : 'Documents'"
    icon="pi pi-file"
    styleClass="p-button-sm"
    [disabled]="docCount === 0"
    [pTooltip]="
      docCount === 0
        ? 'No documents uploaded for this service type'
        : 'View documents for this service type (' + docCount + ')'
    "
    tooltipPosition="top"
    [showDelay]="500"
    (onClick)="openView('document')"
  ></p-button>
  <p-button
    [label]="imageCount > 0 ? 'Images (' + imageCount + ')' : 'Images'"
    icon="pi pi-image"
    styleClass="p-button-sm"
    [disabled]="imageCount === 0"
    [pTooltip]="
      imageCount === 0
        ? 'No images uploaded for this service type'
        : 'View images for this service type (' + imageCount + ')'
    "
    tooltipPosition="top"
    [showDelay]="500"
    (onClick)="openView('image')"
  ></p-button>
</div>

<div *ngIf="!panel" class="flex gap-2 flex-wrap align-items-center">
  <span *ngIf="label" class="text-700 font-medium">{{ label }}</span>
  <!-- View-only (e.g. arrangement transfer panel): plain buttons, no upload. -->
  <ng-container *ngIf="viewOnly">
    <p-button label="Documents" icon="pi pi-file" [styleClass]="compact ? 'p-button-sm' : ''" (onClick)="openView('document')"></p-button>
    <p-button label="Images" icon="pi pi-image" [styleClass]="compact ? 'p-button-sm' : ''" (onClick)="openView('image')"></p-button>
  </ng-container>
  <!-- Full (provider catalogue): view + upload via split-button. -->
  <ng-container *ngIf="!viewOnly">
    <p-splitButton
      label="Documents"
      icon="pi pi-file"
      [styleClass]="compact ? 'p-button-sm' : ''"
      (onClick)="openView('document')"
      [model]="[{ label: 'Upload documents', icon: 'pi pi-upload', command: uploadDocuments }]"
    ></p-splitButton>
    <p-splitButton
      label="Images"
      icon="pi pi-image"
      [styleClass]="compact ? 'p-button-sm' : ''"
      (onClick)="openView('image')"
      [model]="[{ label: 'Upload images', icon: 'pi pi-upload', command: uploadImages }]"
    ></p-splitButton>
  </ng-container>
</div>
